import { defineStore } from "pinia";

export const useTrainingPlanStore = defineStore('trainingPlan', {
    state: () => ({
        plan: {},
        trainingPlans: [],
    }),
    actions: {
        getMax() {
            if(this.trainingPlans.length > 0) {
                return this.trainingPlans[0].id;
            }
            return null;
        },
        setTrainingPlan(trainingPlan) {
            this.trainingPlan = trainingPlan
        },
        setTrainingPlans(trainingPlans) {
            this.trainingPlans = trainingPlans
        },
        addTrainingPlan(trainingPlan) {
            this.trainingPlans.unshift(trainingPlan)
            this.plan = trainingPlan;
        },
        updateTrainingPlan(trainingPlan) {
            let index = this.trainingPlans.findIndex(cl => cl.id === trainingPlan.id)
            this.trainingPlans.splice(index, 1, trainingPlan)
            this.plan = trainingPlan;
        },
        deleteTrainingPlan(trainingPlan) {
            let index = this.trainingPlans.findIndex(cl => cl.id === trainingPlan.id)
            this.trainingPlans.splice(index, 1)
            this.plan = {};
        },
    },
});